import { Message } from "theme-ui";
import * as React from 'react';
export default {
  Message,
  React
};